import { render, staticRenderFns } from "./TypeSelector.vue?vue&type=template&id=7fca9900&scoped=true&"
import script from "./TypeSelector.vue?vue&type=script&lang=js&"
export * from "./TypeSelector.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fca9900",
  null
  
)

export default component.exports